
import "./style/sign.css";
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../contextApi/ContextApi';
import { SignContext } from '../../../contextApi/SignContext';
import NotFound404 from '../../NotFound404';
import SignInput from './signComponents/SignInput';

export default function Signin({website, _minWidth, _height}) {
  const { primary_color, accent_color, secondary_color, setCurrentUser, setConnected, setCurrentUserUID, cookiesApprooved, setToastMessage } = useContext(AppContext);
  const { findUser, setSigninEmail, setSigninPass, signinFlag} = useContext(SignContext);
  const nav = useNavigate();
    
  if(!cookiesApprooved){return <NotFound404/>}
  return (
    <div className='sign_container' dir='rtl'>
      <div className='sign_form_container'>
        <form className="sign_form" style={{minWidth:`${_minWidth}px`, height:`${_height}vh`, backgroundColor:primary_color, color:accent_color, border:`0.5px solid ${accent_color}`, boxShadow:`2px 2px 4px ${accent_color}`}} onSubmit={(e)=>{e.preventDefault(); findUser(website, nav, setCurrentUser, setConnected, setCurrentUserUID, setToastMessage)}}>
          <div className="sign_form_inputsDiv">
            <SignInput _class={"sign_form_oneInputsDiv"} id={"sign_email"} label={"אימייל"} type={"email"} placeholder={"myName@mail.com"} autoCompleteType={"email"} setState={setSigninEmail}/>
            <SignInput _class={"sign_form_oneInputsDiv"} id={"sign_pass"} label={"סיסמא"} type={"password"} placeholder={"SomeP@$$w0rd123"} autoCompleteType={"password"} setState={setSigninPass}/>
          </div>
          <button className='sign_btn' disabled={signinFlag} style={{backgroundColor:secondary_color, color:accent_color}}>{signinFlag ? "המתן..." : "התחבר"}</button>
        </form>
      </div>
      <a className='signin_signupButton' style={{color:accent_color,textShadow:`2px 2px 4px ${primary_color}`}} href={`/${website?.settings?.domain}/signup`}>עדיין אין לי משתמש</a>
    </div>
  )
}
